import { render, staticRenderFns } from "./AdminHeader.vue?vue&type=template&id=991c91a2&scoped=true&"
import script from "./AdminHeader.vue?vue&type=script&lang=js&"
export * from "./AdminHeader.vue?vue&type=script&lang=js&"
import style0 from "./AdminHeader.vue?vue&type=style&index=0&id=991c91a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991c91a2",
  null
  
)

export default component.exports